import React from 'react';
import { Section } from './primitives';
import ToolGrid from './ToolGrid';
import NotesCard from './NotesCard';

/** Overview for a data-driven rotation: the notes card, then each tool section */
const OverviewTab = ({ data, onAction }) => (
  <div className="space-y-6">
    {data.notesKey && (
      <Section title="Personal">
        <NotesCard storageKey={data.notesKey} accent={data.accent} onOpen={() => onAction?.('notes')} />
      </Section>
    )}
    {(data.toolSections || []).map((section) => (
      <Section key={section.title} title={section.title}>
        <ToolGrid tools={section.tools} accent={data.accent} onAction={onAction} />
      </Section>
    ))}
  </div>
);

export default OverviewTab;
